import React, {PropsWithChildren, useEffect} from 'react';
import {IntlProvider} from 'react-intl';
import {observer} from 'mobx-react-lite';
import {useService} from '@yosmanyga/di';
import translations from './translations';
import {WithLanguageController} from '../controller';

const WithLanguage = observer(({children}: PropsWithChildren) => {
    const withLanguageController = useService(WithLanguageController, []);

    useEffect(() => {
        (async () => {
            await withLanguageController.load();
        })();
    }, []);

    if (!withLanguageController.loaded) {
        return null;
    }

    return <IntlProvider
        messages={translations(withLanguageController.language)}
        locale={withLanguageController.language}
    >
        {children}
    </IntlProvider>
});

export {WithLanguage};
